import type { BrokerProduct } from '@/services/brokers/types';

export interface ProductGroup {
  key: string;
  label: string;
  products: BrokerProduct[];
}

interface ProductGroupDefinition {
  key: string;
  label: string;
}

/**
 * Mapeia a categoria do produto retornada pela API para o agrupamento exibido
 * na tela. Categorias distintas podem compartilhar o mesmo agrupamento:
 * - HOME_INSURANCE e BUSINESS_INSURANCE fazem parte de "Patrimonial".
 * - OTHER faz parte de "Vida/Pessoas".
 */
const CATEGORY_TO_GROUP: Record<string, ProductGroupDefinition> = {
  HOME_INSURANCE: { key: 'PATRIMONIAL', label: 'Patrimonial' },
  BUSINESS_INSURANCE: { key: 'PATRIMONIAL', label: 'Patrimonial' },
  OTHER: { key: 'LIFE', label: 'Vida/Pessoas' },
};

export function getProductGroup(category?: string): ProductGroupDefinition {
  const normalized = category || 'DEFAULT';
  const mapped = CATEGORY_TO_GROUP[normalized];
  if (mapped) return mapped;

  return {
    key: normalized,
    label:
      normalized === 'DEFAULT' ? 'DEFAULT' : normalized.split('_').join(' '),
  };
}

export function groupProductsByGroup(
  products: BrokerProduct[]
): ProductGroup[] {
  const groups = products.reduce(
    (acc, product) => {
      const { key, label } = getProductGroup(product.category);
      acc[key] ||= { key, label, products: [] };
      acc[key].products.push(product);
      return acc;
    },
    {} as Record<string, ProductGroup>
  );

  return Object.values(groups).sort((a, b) => a.label.localeCompare(b.label));
}
